import { Page } from "@/models";
import { BaixaDePagamento, BaixaDePagamentoAuditada } from "@/models/financeiro/BaixaDePagamento";
import { Inject } from 'inversify-props';
import type { BaixaDePagamentoServiceAdapter } from "./adapter/BaixaDePagamentoServiceAdapter";
import { AxiosRequestConfig } from "axios";

export class FindBaixaDePagamentoUseCase {
	@Inject("BaixaDePagamentoServiceAdapter")
	private baixaDePagamentoServiceAdapter!: BaixaDePagamentoServiceAdapter


	findByTituloId = async (params?: any, config?: AxiosRequestConfig): Promise<Page<BaixaDePagamentoAuditada>> =>
		await this.baixaDePagamentoServiceAdapter.find(params, config)

	imprimirBaixaDePagamento = async(baixaDePagamento: BaixaDePagamento): Promise<any> =>
		await this.baixaDePagamentoServiceAdapter.imprimirBaixaDePagamento(baixaDePagamento)

	findBaixaById = async(id: string): Promise<BaixaDePagamento> =>
		await this.baixaDePagamentoServiceAdapter.findById(id);
}